import styled from "@emotion/styled";
import { Search } from "lucide-react";

export const StyleTableResponsiveWrapper = styled.div`
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  -ms-overflow-style: none;
  max-width: 100%;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const StyleTableWrapper = styled.div<{ borderRadius?: number }>`
  display: flex;
  flex-direction: column;
  background-color: ${(props: any) => props.theme.colors.white};
  border: 1px solid ${(props: any) => props.theme.colors.borderColor};
  overflow-y: scroll;
  overflow-x: hidden;
  border-radius: ${(props: any) => props.borderRadius ?? 16}px;
  height: 100%;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  overflow: hidden;
`;
export const StyleTableTitle = styled.p`
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 10px;
`;
export const StyleTableSearchWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  position: relative;
  padding: 10px 10px;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  @media (max-width: 768px) {
    flex-direction: column;
    width: 100%;
  }
`;
export const StyleTableSearchInput = styled.input`
  width: 100%;
  transform: translateX(-20px);
  height: 40px;
  border: 1px solid ${(props: any) => props.theme.colors.borderColor};
  border-radius: 10px;
  outline: none;
  color: ${(props: any) => props.theme.colors.border};
  padding: 0 0 0 10px;
  &::placeholder {
    font-size: 14px;
    color: ${(props: any) => props.theme.colors.placeholder};
    letter-spacing: 0.25px;
    line-height: 20px;
  }
  @media (max-width: 768px) {
    transform: translateX(20px);
  }
`;
export const StyleSearchIcon = styled(Search)`
  color: ${(props: any) => props.theme.colors.placeholder};
  position: absolute;
  left: -35px;
  top: 47.5%;
  transform: translateY(-50%);
  width: 1.1rem;
  pointer-events: none;
  display: none;
`;
export const StyledExportButton = styled.button`
  width: 100px;
  height: 30px;
  border-radius: 5px;
  padding: 0 10px;
  background-color: ${(props: any) => props.theme.colors.blue500};
  color: ${(props: any) => props.theme.colors.neutral10};
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  border: none;
  svg {
    width: 1.4rem;
    transform: translateY(2px);
  }
`;

export const StyleTable = styled.table`
  border-collapse: collapse;
  width: 100%;
  min-width: 800px;
`;

export const StyleHeadWrapper = styled.thead<{ headerBgColor?: string }>`
  background-color: ${(props: any) => props.theme.orange.orange50};
  height: 60px;
  color: ${(props: any) => props.theme.orange.orange500};
  position: sticky;
  top: 0;
  z-index: 1;
`;
export const StyleTableRow = styled.tr`
  cursor: pointer;
  border-bottom: 1px solid ${(props: any) => props.theme.colors.borderColor};
  transition: all 0.2s ease-in-out;
  &:hover {
    background-color: ${(props: any) => props.theme.colors.lightBlue50}80;
  }
  &:last-child {
    border-bottom: none;
  }
`;
export const StyleHeader = styled.th`
  font-weight: 500;
  font-size: 14px;
`;
export const StyleBodyWrapper = styled.tbody`
  background-color: ${(props: any) => props.theme.colors.white};
`;
export const StyleBodyText = styled.td`
  text-align: center;
  padding: 16px 10px;
  color: ${(props: any) => props.theme.colors.text};
  font-weight: 400;
  font-size: 14px;
  vertical-align: middle;
`;

export const SearchInputWrapper = styled.div`
  position: relative;
  width: 50%;
  display: flex;
  align-items: center;
  transform: translateX(-20px);
  @media (max-width: 768px) {
    flex-direction: column;
    transform: translateX(-20px);
  }
`;

export const Text = styled.div`
  flex: 1;
  color: ${(props: any) => props.theme.colors.text};
  font-size: 18px;
  line-height: 100%;
  letter-spacing: 0.25px;
  font-weight: 400;
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const ActionButtonWrapper = styled.div`
  display: flex;
  gap: 10px;
  justify-content: center;
`;

export const ActionButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;

  svg {
    width: 26px;
    height: 26px;
    color: ${({ theme }: any) => theme.colors.text};
    &:hover {
      color: ${({ theme }: any) => theme.colors.primary};
    }
  }
`;
